// extracted by mini-css-extract-plugin
module.exports = {"invitingrecord":"_1a_gQbTGDj","section":"_1ospQACT94"};